exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header[data-v-a3984c6a] {\n  padding: 15px 34px;\n  display: flex;\n  justify-content: space-between;\n}\n.header h2[data-v-a3984c6a] {\n  font-size: 18px;\n  font-weight: 600;\n}\n.header .status[data-v-a3984c6a] {\n  font-size: 16px;\n}", ""]);

// exports
